export default __webpack_public_path__ + "static/media/program-closed.e9cf39af.svg";